import React, {useEffect, useRef, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {AppBar, Typography} from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import {Close, Crop54, Minimize} from "@material-ui/icons";
import clsx from "clsx";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        boxSizing: 'border-box',
        backgroundColor: 'white',
        overflow: 'hidden',
        '&.open': {
            display: 'block'
        },
        '&.minimized': {
            top: 'calc(100% - 48px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: 'auto',
            left: 'auto',
            bottom: 0,
            width: 350,
            height: 550,
            boxShadow: theme.shadows[5],
            '&.minimized': {
                height: 48
            }
        }
    },
    grow: {
        flexGrow: 1
    },
    button: {
        color: 'white'
    },
    appBar: {
        paddingLeft: theme.spacing(2),
        backgroundColor: theme.palette.tertiary.main
    },
    iframe: {
        border: 0,
        margin: 0,
        padding: 0,
        width: '100%',
        height: 'calc(100% - 48px)',
        backgroundColor: 'white'
    }
}));

export default function ChatBox(props) {
    const {
        open,
        onClose
    } = props;
    const classes = useStyles();
    const iframeRef = useRef();
    const [minimized, setMinimized] = useState(false);

    const toogleMinimize = () => setMinimized(prevMinimized => !prevMinimized);

    return (
        <div className={clsx(classes.root, open && 'open', minimized && 'minimized')}>
            <AppBar position="static" className={classes.appBar}>
                <Toolbar variant='dense' disableGutters>
                    <Typography variant="h6" className={classes.grow}>
                        Atendimento Online
                    </Typography>
                    <IconButton
                        onClick={toogleMinimize}
                        className={classes.button}>
                        {!minimized ? <Minimize /> : <Crop54 />}
                    </IconButton>
                    <IconButton
                        onClick={onClose}
                        className={classes.button}>
                        <Close />
                    </IconButton>
                </Toolbar>
            </AppBar>
            {open && (
                <iframe
                    ref={iframeRef}
                    src='https://www3.unaerp.br/Chat/#/identificacao/6' className={classes.iframe} />
            )}
        </div>
    );
};

ChatBox.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};